<!-- eslint-disable -->
<template lang="pug">
    div(@mousedown.prevent="")
        datepicker-header(
            :previousTime="previousDecade"
            :nextTime="nextDecade"
            :showCalendar="function(){}"
            :headerText="getPageDecade"
        )
        datepicker-calendar(
            time="Year"
            :items="years"
            :select="selectYear"
        )
</template>

<script>
    /*eslint-disable*/
    import PickerYear from "../../../node_modules/vuejs-datepicker/src/components/PickerYear.vue"
    import DatepickerHeader from "./DatepickerHeader.vue"
    import DatepickerCalendar from "./DatepickerCalendar.vue"

    export default {
        name: "PickerYear",
        status: "ready",
        release: "1.0.0",
        extends: PickerYear,
        components: {
            DatepickerHeader,
            DatepickerCalendar,
        },
    }
</script>
